<template lang="pug">
.design-data-container(@click="expand = !expand")
  .design-data
    .design-name
      span.material-symbols-outlined palette
      span.tag {{ data.design }}

    .design-transaction(v-if="history" :class="colorTransaction(data.transaction)") {{ data.transaction }}

    .design-date(v-if="history") {{ dateName(data.createdAt) }} - {{ time(data.createdAt) }}

  transition(name="slide-fade")
    shForm.list-design(v-if="expand && !history" :dataOriginal="data" :fillData="true" @click.native.stop="")

  transition(name="slide-fade")
    shHistory.list-design(v-if="expand && history" :dataOriginal="data" :color="colorTransaction(data.transaction)" @click.native.stop="")
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'

export default {
  name: 'Design',

  mixins: [mFilters, mForm],

  components: { shForm, shHistory },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false
    }
  },

  beforeDestroy () {
    this.expand = false
  }
}
</script>

<style lang="stylus">
.design-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em

.design-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis 100%
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em

.design-name
  display flex
  align-items center
  gap .5em

.list-design
  flex-basis 100%
  flex-shrink 0
  width 100%

@media (pointer: fine)
  .design-data
    column-gap 0
    row-gap 1em

  .design-name
    width 14em
  .design-transaction
    width 8em
  .design-date
    width 10em
</style>



// WEBPACK FOOTER //
// src/components/pages/design/Design.vue